import React from 'react';
import { compose } from 'redux';
import DashboardTemplate from 'components/templates/Dashboard';
import HeaderContainer from 'containers/HeaderContainer';
import PageQuery from 'hoc/PageQuery';
import PageView from 'hoc/PageView';
import PageTitle from 'hoc/PageTitle';
import ProtectedRoute from 'hoc/ProtectedRoute';
import PageTheme from 'hoc/PageTheme';

import DetermineLayerContainer from 'containers/dashboards/DetermineLayerContainer';
import LayerThreeSocialContainer from 'containers/dashboards/LayerThreeSocialContainer';

import SideBarContainer from 'containers/SideBarContainer';
import TitleContainer from 'containers/TitleContainer';
import { SideBarObjects } from 'components/pages/config/DashboardSideBarObjects';
import showGGBrandingTheme from 'helpers/showGGBrandingTheme';
import { getQueryParamDefForRange } from 'helpers/range';

const SocialDashboard = props => (
    <DashboardTemplate
        header={<HeaderContainer />}
        sidebar={<SideBarContainer navItems={SideBarObjects} />}
        title={<TitleContainer entityId={parseInt(props.match.params.entityId, 10)}/>}>

        <DetermineLayerContainer
            layerTwo={LayerThreeSocialContainer}
            layerThree={LayerThreeSocialContainer}
            {...props} />
    </DashboardTemplate>
);

export default compose(
    ProtectedRoute(),
    PageTitle({ pageTitle: 'Social' }),
    PageView({ page: 'Viewed Entity Social', trackEntity: true }),
    PageTheme({ themeDefaults: { 'whitelabel.showGGBranding': showGGBrandingTheme } }),
    PageQuery({
        params: {
            ...getQueryParamDefForRange()
        },
        initialTruth: 'location',
    }),
)(SocialDashboard);



// WEBPACK FOOTER //
// ./src/components/pages/dashboards/Social.js